import { useState } from 'react';

import * as T from '../../../../components/Typography';
import EmptySpace from '../../../../components/EmptySpace';
import Option from '../../../../components/Option';
import * as S from './style';
import * as SS from '../shared/style';
import { showMovingBlock } from '../../../../helpers';
import TryAgainModal from '../../../../components/Modal/TryAgainModal';
import StepFooterButtons from '../StepFooterButtons';
import { PlayButton } from 'components/Button';
import { useSiteSettings } from 'context/site-settings';

const WordJoin2 = ({
  data: {
    textAudio,
    textAudioUrl,
    options: _options = [],
    correctOptions = [],
  } = {},
  handleNext,
  stuckAtReview,
  preview,
  cmsPreview,
}) => {
  const { courseCode } = useSiteSettings();
  const [disableCheck, setDisableCheck] = useState(false);
  const [activePosition, setActivePosition] = useState(0);

  const [showTryAgain, setShowTryAgain] = useState(false);

  const options = _options.map((op, i) => ({ option: op.option, id: i }));

  const [answers, setAnswers] = useState(correctOptions.map(() => null));

  const onClickAnswer = (row, answer) => {
    if (answer?.option) {
      setActivePosition(row);
      showMovingBlock({
        OptionElId: `option-${answer.id}`,
        answerElId: `answer-${row}`,
        movingElId: 'moving-div',
        isBeingSelected: true,
      });
      setAnswers((_answers) =>
        _answers.map((answer, ir) => {
          if (ir === row) {
            return null;
          } else {
            return answer;
          }
        })
      );
    } else {
      setActivePosition(row);
    }
  };

  const onFocusAnswer = (row) => {
    setActivePosition(row);
  };

  const onClickOption = (option) => {
    setDisableCheck(true);
    showMovingBlock({
      OptionElId: `option-${option.id}`,
      answerElId: `answer-${activePosition}`,
      movingElId: 'moving-div',
      isBeingSelected: false,
      done: () => {
        setAnswers((_answers) =>
          _answers.map((answer, ir) => {
            if (ir === activePosition) {
              return option;
            } else {
              return answer;
            }
          })
        );
        setDisableCheck(false);
      },
    });

    setActivePosition((_activePosition) =>
      Math.min(_activePosition + 1, answers.length - 1)
    );
  };

  const validateRow = (row) => {
    const currentAnswer = answers[row]?.option;
    return !!correctOptions[row]?.answers.find((e) => e === currentAnswer);
  };

  const onNext = () => {
    const allCorrect = answers.every((e, i) => validateRow(i));

    if (allCorrect || stuckAtReview) {
      handleNext();
    } else {
      setShowTryAgain(true);
    }
  };

  return (
    <S.Wrapper>
      {textAudio ? (
        <SS.TextAudioWrapper ml={3} mlM={1} mlT={2} mt={1} mb={7}>
          {textAudioUrl ? (
            <>
              <PlayButton
                audioUrl={textAudioUrl}
                width="56px"
                height="56px"
                iconProps={{ width: '32px', height: '32px' }}
                fallbackText={textAudio}
              />
              <T.P ml={3} weight="regular" size="med">
                {textAudio}
              </T.P>
            </>
          ) : (
            <T.P weight="regular" size="med">
              {textAudio}
            </T.P>
          )}
        </SS.TextAudioWrapper>
      ) : null}
      {/* keep this to animation */}
      <div style={{ display: 'none' }}>
        <Option id="moving-div"></Option>
      </div>
      <TryAgainModal
        isModalVisible={showTryAgain}
        setIsModalVisible={setShowTryAgain}
      />
      <S.ItemsWrapper courseCode={courseCode}>
        {answers.map((answer, ir) => (
          <S.Item courseCode={courseCode}>
            <T.P size="large" mr={2}>
              {correctOptions[ir].pre}
            </T.P>
            <EmptySpace
              isActive={ir === activePosition && !cmsPreview}
              onClick={() => onClickAnswer(ir, answer)}
              onFocus={() => onFocusAnswer(ir)}
              id={`answer-${ir}`}
              bgColor={
                answer?.id ? 'rgba(255, 255, 255, 0.5)' : 'neutralSurface'
              }
              key={`${ir}`}
              disabled={ir !== activePosition}
              w="78px"
              h="58px"
              size="large"
              fontSize="20px"
            >
              {answer?.option}
            </EmptySpace>
            <T.P size="large"> {correctOptions[ir].post}</T.P>
          </S.Item>
        ))}
      </S.ItemsWrapper>

      <S.OptionsGridWrapper
        ai={options.length === 1 ? 'flex-start' : 'flex-end'}
      >
        <S.OptionsGrid jc="center">
          {options.map((op) => (
            <Option
              m={1}
              onClick={() => onClickOption(op)}
              id={`option-${op.id}`}
              key={op.id}
              style={{ minWidth: '74px' }}
              fontSize="20px"
            >
              {op.option}
            </Option>
          ))}
        </S.OptionsGrid>
      </S.OptionsGridWrapper>

      {(!_options || !correctOptions) && (
        <T.P color="error">Exercise missing required fields </T.P>
      )}
      <StepFooterButtons
        stuckAtReview={stuckAtReview}
        handleNext={onNext}
        preview={preview}
        disabled={disableCheck}
        enableNext={
          answers.filter((e) => e?.option).length >= correctOptions.length
        }
      />
    </S.Wrapper>
  );
};

export default WordJoin2;
